import { BadgeOption } from 'src/types';
import { ICON_MAP } from 'src/utils/constants';
import { WEBHOOK_EVENT_STATUS } from 'src/features/webhook-events/utils/types';
import { webhookEventsMessages } from 'src/features/webhook-events/utils/messages';

export const WEBHOOK_EVENT_STATUS_BADGE_MAP: Record<WEBHOOK_EVENT_STATUS, BadgeOption> = {
    [WEBHOOK_EVENT_STATUS.PENDING]: {
        label: webhookEventsMessages.pending,
        icon: ICON_MAP.FROZEN,
        theme: 'gray',
    },
    [WEBHOOK_EVENT_STATUS.SENDING]: {
        label: webhookEventsMessages.sending,
        icon: ICON_MAP.SENDING,
        theme: 'blue',
    },
    [WEBHOOK_EVENT_STATUS.DELIVERED]: {
        label: webhookEventsMessages.delivered,
        icon: ICON_MAP.CHECK,
        theme: 'green',
    },
    [WEBHOOK_EVENT_STATUS.FAILED]: {
        label: webhookEventsMessages.failed,
        icon: ICON_MAP.X_MARK,
        theme: 'red',
    },
    [WEBHOOK_EVENT_STATUS.EXHAUSTED]: {
        label: webhookEventsMessages.exhausted,
        icon: ICON_MAP.X_MARK,
        theme: 'orange',
    },
};
